export const sweep = "_ab";
export const undoCommandingBar = "$ab";
export const previousLabel = "abb";
export const nextLabel = "bbb";
export const closeLabel = "cbb";
export const customizeToolbar = "dbb";
export default {sweep,undoCommandingBar,previousLabel,nextLabel,closeLabel,customizeToolbar};